export default {
  AT: {
    changeLabels: { routingNumber: 'Bankleitzahl, BLZ', accountNumber: 'Kontonummer, Kto.' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  AU: {
    changeLabels: { branchCode: 'BSB number' },
    onlyLocalDetails: true,
    disabledFields: ['routingNumber', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  AX: {
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  BE: {
    changeLabels: { accountNumber: 'Rekeningnummer/Numéro de compte' },
    disabledFields: ['branchCode', 'routingNumber', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  CA: {
    changeLabels: { routingNumber: 'Institution number', branchCode: 'Transit number' },
    onlyLocalDetails: true,
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  CY: {
    changeLabels: { routingNumber: 'Kodikos Trapezas', accountNumber: 'Arithmos Logariasmou', branchCode: 'Kodikos Katastimatos' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  DE: {
    changeLabels: { accountNumber: 'Kontonummer', routingNumber: 'Bankleitzahl' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  DK: {
    changeLabels: { accountNumber: 'Kontonummer', routingNumber: 'Registreringsnummer' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'swedishIdentityNumber'],
  },
  EE: {
    disabledFields: ['branchCode', 'routingNumber', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  ES: {
    changeLabels: { routingNumber: 'Código de entidad', accountNumber: 'Número de cuenta', branchCode: 'Código de oficina' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  FI: {
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  FR: {
    changeLabels: { routingNumber: 'Code banque', branchCode: 'Code guichet', accountNumber: 'Numéro de compte' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  GB: {
    changeLabels: { branchCode: 'Sort Code' },
    disabledFields: ['routingNumber', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  GF: {
    changeLabels: { routingNumber: 'Code banque', branchCode: 'Code guichet', accountNumber: 'Numéro de compte' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  GR: {
    changeLabels: { routingNumber: 'Kodikos Trapezas', branchCode: 'Kodikos Katastimatos', accountNumber: 'Arithmos Logariasmou' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  IE: {
    changeLabels: { branchCode: 'Sort code' },
    disabledFields: ['routingNumber', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  IT: {
    changeLabels: { routingNumber: 'Codice ABI', branchCode: 'CAB', accountNumber: 'Numero di conto' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  LT: {
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  LU: {
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  LV: {
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  MC: {
    changeLabels: { routingNumber: 'Code banque', branchCode: 'Code guichet', accountNumber: 'Numéro de compte' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  MT: {
    changeLabels: { routingNumber: 'Sort code', accountNumber: 'Numru tal‑kont bankarju' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  NL: {
    changeLabels: { accountNumber: 'Rekeningnummer' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  NZ: {
    changeLabels: { address2: 'Suburb' },
    onlyLocalDetails: true,
    disabledFields: ['accountType', 'accountType', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  PL: {
    changeLabels: { routingNumber: 'Bank Identifier', accountNumber: 'Account Number' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  PT: {
    changeLabels: { routingNumber: 'Código de Banco', branchCode: 'Código de Balcão', accountNumber: 'Número de conta' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  SE: {
    changeLabels: { branchCode: 'Clearingnummer', accountNumber: 'Kontonummer' },
    onlyLocalDetails: true,
    disabledFields: ['routingNumber', 'accountType', 'phone', 'danishIdentityNumber'],
  },
  SI: {
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  SK: {
    changeLabels: { routingNumber: 'Předčíslí', accountNumber: 'Číslo účtu' },
    disabledFields: ['branchCode', 'accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  SM: {
    changeLabels: { routingNumber: 'Codice ABI', branchCode: 'CAB', accountNumber: 'Numero di conto' },
    disabledFields: ['accountType', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  },
  US: {
    onlyLocalDetails: true,
    disabledFields: ['branchCode', 'phone', 'danishIdentityNumber', 'swedishIdentityNumber'],
  }
};
